import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { TeacherAvailibiltyComponent } from '../teacher-availibilty/teacher-availibilty.component';
import { UmsService } from '../ums.service';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TeacherReportComponent } from '../teacher-report/teacher-report.component';

@Component({
  selector: 'app-teacher-availibilty-data',
  templateUrl: './teacher-availibilty-data.component.html',
  styleUrls: ['./teacher-availibilty-data.component.scss']
})
export class TeacherAvailibiltyDataComponent implements OnInit {
  ExaminerList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  Session: any;
  userPermission: any;
  constructor(public umsService: UmsService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService) { }

  UserCollege: any;
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));


    this.fetchSecretData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.Session = res.projectPharam['SnNo']
      this.getAvailabilityTeacher();
    }
    );
  }
  addnewrecord() {
    const dialogRef = this.dialog.open(TeacherAvailibiltyComponent, {
      width: 'auto',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAvailabilityTeacher();
    });
  }
  Panel31() {
    const dialogRef = this.dialog.open(TeacherAvailibiltyComponent, {
      width: 'auto',
      data: { key: "31(a)" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAvailabilityTeacher();
    });
  }

  Report() {
     let data = {};
    data['isFinal'] = 0;
    const dialogRef = this.dialog.open(TeacherReportComponent, {
      width: 'auto',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAvailabilityTeacher();
    });
  }


  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getAvailabilityTeacher();
    // this.keypress()
  }
  getAvailabilityTeacher() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.spinner.show();
    let payload = {};
    payload['SessionId'] = this.Session;
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CgCode'] = this.UserCollege;
    this.umsService.getTeacherAvailablity(payload).subscribe(res => {
      this.spinner.hide();
      this.ExaminerList = res.data;
      this.totalItems = res.data[0].TotalRecords;
      if (res.status) {

      } else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();

    });
  }
}
